import { Link } from "react-router-dom";
import Button from "@/components/ui/Button";
import {
  useHomePageContent,
  HOME_DEFAULTS,
} from "@/features/admin-content/hooks/usePageContent";

export default function Dining() {
  const { data } = useHomePageContent();
  const image = data?.dining.image ?? HOME_DEFAULTS.dining.image;

  return (
    <section id="dining" className="bg-metro-cream py-24">
      <div className="container-narrow">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <div>
            <p className="eyebrow mb-3">Dine &amp; Drink</p>
            <h2 className="mb-6 font-serif text-display-md text-metro-green-950">
              Dine at Metropolis
            </h2>
            <p className="mb-6 text-base leading-relaxed text-metro-ink-muted">
              Dining at Metropolis is an experience inspired by the rich culture
              and flavours of Kashmir. Our menu brings together Indian, Chinese,
              and Continental cuisines while celebrating the authenticity of
              Kashmiri culinary traditions — from the delicate aroma of saffron
              to the comfort of freshly brewed Kahwa.
            </p>
            <p className="mb-8 text-sm text-metro-green-900">
              <strong>Breakfast:</strong> 8:00 AM — 11:00 AM &nbsp;·&nbsp;{" "}
              <strong>Complimentary</strong> for in-house guests
            </p>
            <Link to="/dining">
              <Button variant="outline">Dining With Us</Button>
            </Link>
          </div>

          <div className="h-[420px] overflow-hidden rounded-2xl">
            {image && (
              <img
                src={image}
                alt="Dine at Metropolis"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}